import { BlockInViewOnlyMode } from "@circle-react/components/ViewOnlyMasquerading/BlockInViewOnlyMode";

import { t } from "@/i18n-js/instance";

import { SidebarItem } from "../SidebarItem";
import { useAddLinkModal } from "./AddLinkModal";

export const AddLinkButton = () => {
  const addLinkModal = useAddLinkModal();

  return (
    <BlockInViewOnlyMode>
      <SidebarItem
        onClick={() => {
          void addLinkModal.show();
        }}
      >
        <SidebarItem.Content label={t("add_link")} startIcon="plus" />
      </SidebarItem>
    </BlockInViewOnlyMode>
  );
};
